/**
 * Returns the viewed shop's id when it differs from the authed user's own
 * shop — the Postscript admin/sales-agent case, where requests must target
 * the viewed shop explicitly. Merchants viewing their own shop get undefined
 * so requests keep the JWT fallback; forcing shop_id could trip the backend's
 * sales-authorization check for non-agent users. When the viewer's shop is
 * unknown (user context still loading), also returns undefined for the same
 * reason — cross-shop can't be established yet.
 */
export const getCrossShopId = (
  viewedShopId: number | undefined,
  userShopId: number | undefined,
): number | undefined =>
  typeof viewedShopId === 'number' &&
  typeof userShopId === 'number' &&
  viewedShopId !== userShopId
    ? viewedShopId
    : undefined;
